import { Component } from "@angular/core";
import { ModalController, NavParams} from "@ionic/angular";
import { CotationService } from "src/app/Services/Cotation/cotation.service";


@Component({
  selector: "app-CouvertureComponent",
  templateUrl: "./Couverture.component.html",
  styleUrls: ["./Couverture.component.scss"],
})
export class CouvertureComponent {
  indeterminateState: boolean;
  checkParent: boolean;
  Checkboxes: any[];
  dte:string
  constructor(
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private _cotationService: CotationService
  ) {
    let result = this.nvparms.get('value');
    this.dte=result.dte
    if (result.p1===result.p2 && result.p2===result.p3 && result.p3==="1"){
      this.Checkboxes = [
        {
          value: "3 mois",
          isItemChecked: false
        }, {
          value: "6 mois",
          isItemChecked: false
        }, {
          value: "12 mois",
          isItemChecked: false
        }
      ]
    }
    else if(result.p1==="0" && result.p2==="0" && result.p3==="1"){
      this.Checkboxes = [
        {
          value: "12 mois",
          isItemChecked: false
        }
      ]
    }
  
  }

  async onCloseModal() {
    this.modalcontroller.dismiss();
  }

  checkCheckbox() {
    setTimeout(() => {
      this.Checkboxes.forEach(item => {
        item.isItemChecked = this.checkParent;
      });
    });
  }

  verifyEvent() {
    const allItems = this.Checkboxes.length;
    let selected = 0;

    this.Checkboxes.map(item => {
      if (item.isItemChecked) selected++;
    });

    if (selected > 0 && selected < allItems) {
      // One item is selected among all checkbox elements
      this.indeterminateState = true;
      this.checkParent = false;
    } else if (selected == allItems) {
      // All item selected
      this.checkParent = true;
      this.indeterminateState = false;
    } else {
      // No item is selected
      this.indeterminateState = false;
      this.checkParent = false;
    }
  }

  onValide(){

    if (this.Checkboxes.filter(e => e.isItemChecked).length>0) {
      this.modalcontroller.dismiss();
      this._cotationService.couverture.next(this.Checkboxes)
    }
  }

}
